/**
 * Default key (used for a StorageBackedNumber) to represent last session
 * activity timestamp.
 */
export const LAST_ACTIVITY_KEY = 'session-last-activity-unix-ms';

/**
 * Simple type-safe wrapper around a number which is persisted to localStorage.
 */
export class StorageBackedNumber {

  constructor(private storageKey: string) {}

  public setVal(val: number | null): void {
    if (val === null) {
      localStorage.removeItem(this.storageKey);
    } else {
      localStorage.setItem(this.storageKey, JSON.stringify(val));
    }
  }

  public getVal(): number | null {
    const storageVal = localStorage.getItem(this.storageKey);

    if (storageVal === null) {
      return null;
    }

    try {
      const parsedVal = JSON.parse(storageVal);

      if ('number' === typeof parsedVal) {
        return parsedVal;
      }
    } catch {
      return null;
    }

    return null;
  }
}
